import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";

import { CarSearch } from "@tenant/cars";
import { useHomePageCarSearch } from "@tenant/cars";
import { Icon } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./HomePageCarSearch.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import {
  CarsRawEventName,
  useEmitCoreCarsRawEventOnce,
} from "~core-cars/tracking";
import { CoreCarsComponent } from "~core-cars/types";

export type HomePageCarSearchComponentProps = PlatformComponentProps;
export const HomePageCarSearch = ({
  children,
  className,
}: HomePageCarSearchComponentProps) => {
  const COMPONENT_KEY = CoreCarsComponent.HomePageCarSearch;
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { handlers, text } = useHomePageCarSearch();

  useEmitCoreCarsRawEventOnce({ name: CarsRawEventName.CarSearchLoaded });

  return (
    <div className={clsx(block, className)}>
      <div className={cn("search")}>
        <CarSearch />
      </div>
      <div className={cn("search-entry")}>
        <button
          onClick={() => handlers.handleMobileRedirect()}
          className={cn("start-search-button")}
        >
          <Icon iconName={IconNameEnum.search} className={cn("button-icon")} />
          {text.mobileButtonLabel}
        </button>
      </div>
      {children}
    </div>
  );
};
